import { render, staticRenderFns } from "./genomics-pos-info.vue?vue&type=template&id=71de7896&scoped=true"
import script from "./genomics-pos-info.vue?vue&type=script&lang=js"
export * from "./genomics-pos-info.vue?vue&type=script&lang=js"
import style0 from "./genomics-pos-info.vue?vue&type=style&index=0&id=71de7896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71de7896",
  null
  
)

export default component.exports